var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-table',{attrs:{"url":"accdocdetail","title":"لیست گردش حساب","detailUrl":"editDocument","newUrl":"newDocument","fields":_vm.fields,"params":_vm.params}})
}
var staticRenderFns = []

export { render, staticRenderFns }